import type { ReactNode } from 'react'
import { Masthead } from './Masthead'

/** Signed-out / loading frame: the branded masthead + a narrow centered column.
 *  The signed-in app uses AppShell (desktop sidebar, mobile masthead) instead.
 *
 *  That sentence was aspirational for a long time — there was no AppShell, and
 *  this shell served the signed-in app too, which is what `.impeccable.md`
 *  recorded as the fields-spa chrome drift. AppShell now exists, so this is back
 *  to its stated job: a login screen and a loading line, both of which want a
 *  narrow measure rather than the app's full width. */
export function Shell({ children, headerRight }: { children: ReactNode; headerRight?: ReactNode }) {
  return (
    <div className="min-h-screen bg-canvas">
      <Masthead headerRight={headerRight} />
      <main className="mx-auto w-full max-w-2xl px-4 py-5">{children}</main>
    </div>
  )
}
